// src/components/Modal.js
import React from 'react';

const Modal = ({ isOpen, onClose, children, title }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center overflow-auto z-[9999]">
            <div className="bg-gray-100 p-6 rounded-lg max-w-6xl w-full max-h-[90%] overflow-auto">

                {/* Modal header */}
                <div className="px-4 py-3 sm:px-6 sm:flex sm:items-center sm:justify-between">
                    <h3 className="text-lg leading-6 font-medium">
                    {title}
                    </h3>
                    <button
                    type="button"
                    className="text-gray-400 focus:outline-none"
                    onClick={onClose}
                    >
                    <span className="sr-only">Close</span>
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    </button>
                </div>

                {/* Modal content */}
                <div className="bg-white px-4 pt-4 pb-4 rounded-md shadow-md sm:p-6 sm:pb-4 mb-2 h-[calc(90%-200px)] overflow-auto">
                    {children}
                </div>

            </div>
        </div>
    );
};

export default Modal;